/* ==========================================================================
   Munchin' Candy — theme.js
   Header / menus · hero slider · cart drawer (+ recommendations) · wishlist
   · product form · Pick & Mix builder
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  var T = window.theme || {};
  var R = T.routes || {};
  var S = T.strings || {};
  var root = document.documentElement;

  /* ---------------- tiny helpers ---------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var moneyFmt = null;
  try { moneyFmt = new Intl.NumberFormat(T.locale || undefined, { style: 'currency', currency: T.currency || 'USD' }); } catch (e) { moneyFmt = null; }
  function money(cents) {
    cents = Number(cents) || 0;
    return moneyFmt ? moneyFmt.format(cents / 100) : '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /* Shopify CDN image resize: .../file.jpg?v=1  ->  .../file_240x.jpg?v=1 */
  function imgSize(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (url.indexOf('cdn.shopify.com') === -1 && url.indexOf('/cdn/shop/') === -1) return url;
    return url.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_' + w + 'x$1$2');
  }

  function jsonFetch(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Accept': 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        if (!res.ok) {
          var err = new Error(data.description || data.message || S.error || 'Request failed');
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }

  /* ---------------- Scroll reveal animations ---------------- */
  var revealEls = $$('.reveal-up, .reveal-left, .reveal-right');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if ('IntersectionObserver' in window && !reduceMotion) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ==========================================================================
     Header: desktop dropdown menus
     ========================================================================== */
  var navItems = $$('.site-nav__item.has-dropdown');
  var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

  function setNavOpen(item, open) {
    var toggle = $('.site-nav__toggle', item);
    var dd = $('.dropdown', item);
    if (open) {
      item.classList.add('is-open');
      if (dd) {
        item.classList.remove('is-flip');
        var r = dd.getBoundingClientRect();
        if (r.right > window.innerWidth - 12) item.classList.add('is-flip');
      }
    } else {
      item.classList.remove('is-open');
    }
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAllNavItems(except) {
    navItems.forEach(function (it) { if (it !== except) setNavOpen(it, false); });
  }

  navItems.forEach(function (item) {
    var timer = null;
    var toggle = $('.site-nav__toggle', item);

    if (canHover) {
      item.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        closeAllNavItems(item);
        setNavOpen(item, true);
      });
      item.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { setNavOpen(item, false); }, 160);
      });
    }

    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var willOpen = !item.classList.contains('is-open');
        closeAllNavItems(item);
        setNavOpen(item, willOpen);
      });
    }

    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) setNavOpen(item, false);
    });

    /* flip nested fly-outs to the left when they would leave the screen */
    $$('.dropdown__item.has-flyout', item).forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        var fly = $('.dropdown__flyout', li);
        if (!fly) return;
        li.classList.remove('flyout-left');
        var fr = fly.getBoundingClientRect();
        if (fr.right > window.innerWidth - 12) li.classList.add('flyout-left');
      });
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.site-nav__item')) closeAllNavItems();
  });

  /* ==========================================================================
     Header: mobile menu (slide-in)
     ========================================================================== */
  var mobileNav = $('#MobileNav');
  var mobileToggle = $('#MobileNavToggle');

  function openMobileNav() {
    if (!mobileNav) return;
    closeAnyDrawer(true);
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'true');
    root.classList.add('drawer-open');
    var p = $('.mobile-nav__panel', mobileNav);
    if (p) setTimeout(function () { p.focus({ preventScroll: true }); }, 50);
  }
  function closeMobileNav(silent) {
    if (!mobileNav || !mobileNav.classList.contains('is-open')) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
    if (!activeDrawer) root.classList.remove('drawer-open');
    if (!silent && mobileToggle) mobileToggle.focus({ preventScroll: true });
  }
  if (mobileToggle) mobileToggle.addEventListener('click', openMobileNav);
  $$('[data-mobile-nav-close]').forEach(function (el) { el.addEventListener('click', function () { closeMobileNav(); }); });
  if (mobileNav) {
    $$('.mobile-nav__row > a, .mobile-nav__sub a', mobileNav).forEach(function (a) {
      a.addEventListener('click', function () { closeMobileNav(true); });
    });
    $$('.mobile-nav__toggle', mobileNav).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var item = btn.closest('.mobile-nav__item');
        var willOpen = !item.classList.contains('is-open');
        $$('.mobile-nav__item.is-open', mobileNav).forEach(function (openItem) {
          openItem.classList.remove('is-open');
          var t = $('.mobile-nav__toggle', openItem);
          if (t) t.setAttribute('aria-expanded', 'false');
        });
        if (willOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
  /* close the mobile menu if the window grows to desktop size */
  window.addEventListener('resize', function () {
    if (window.innerWidth > 1100) closeMobileNav(true);
  });

  /* ---------------- Header shrink on scroll ---------------- */
  var header = $('#SiteHeader');
  var ticking = false;
  function onScroll() {
    if (!header) return;
    header.classList.toggle('is-scrolled', window.scrollY > 40);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
  }, { passive: true });
  onScroll();

  /* ==========================================================================
     Drawers (cart + wishlist) — shared open/close, focus trap, ESC
     ========================================================================== */
  var activeDrawer = null;
  var lastTrigger = null;

  function openDrawer(el, trigger) {
    if (!el) return;
    closeMobileNav(true);
    if (activeDrawer && activeDrawer !== el) closeDrawer(activeDrawer, true);
    if (activeDrawer !== el) lastTrigger = trigger || document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    root.classList.add('drawer-open');
    activeDrawer = el;
    var panel = $('.drawer__panel', el);
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, 60);
  }
  function closeDrawer(el, silent) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (activeDrawer === el) {
      activeDrawer = null;
      if (!(mobileNav && mobileNav.classList.contains('is-open'))) root.classList.remove('drawer-open');
      if (!silent && lastTrigger && lastTrigger.focus && document.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
    }
  }
  function closeAnyDrawer(silent) { if (activeDrawer) closeDrawer(activeDrawer, silent); }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllNavItems();
      if (mobileNav && mobileNav.classList.contains('is-open')) { closeMobileNav(); return; }
      if (activeDrawer) { closeDrawer(activeDrawer); return; }
    }
    if (e.key === 'Tab') {
      var container = activeDrawer || (mobileNav && mobileNav.classList.contains('is-open') ? mobileNav : null);
      if (!container) return;
      var focusables = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', container)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === $('.drawer__panel', container))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ==========================================================================
     CART DRAWER
     ========================================================================== */
  var cartDrawer = $('#cart-drawer');
  var cartItemsEl = $('#cart-drawer-items');
  var cartFooterEl = $('#cart-drawer-footer');
  var cartRecsEl = $('[data-cart-recs]');
  var cartRecsList = $('[data-cart-recs-list]');
  var cartRecsTitle = $('[data-cart-recs-title]');
  var cartErrorEl = $('[data-cart-error]');
  var shippingEl = $('[data-cart-shipping]');
  var cartState = null;
  var recsCache = {};
  var fallbackPromise = null;
  var currentHint = 0;

  function showCartError(msg) {
    if (!cartErrorEl) return;
    if (msg) { cartErrorEl.textContent = msg; cartErrorEl.hidden = false; }
    else { cartErrorEl.textContent = ''; cartErrorEl.hidden = true; }
  }

  function openCart(hintProductId, trigger) {
    if (!cartDrawer) { window.location.href = R.cart || '/cart'; return; }
    showCartError('');
    openDrawer(cartDrawer, trigger);
    return refreshCart(hintProductId);
  }
  function closeCart() { closeDrawer(cartDrawer); }

  /* ---------- single line item ---------- */
  function cartLineHtml(item) {
    var url = item.url || '#';
    var img = item.image
      ? '<img src="' + escapeHtml(imgSize(item.image, 200)) + '" alt="' + escapeHtml(item.product_title) + '" width="88" height="88" loading="lazy">'
      : '<span class="cart-line__noimg" aria-hidden="true"></span>';

    var meta = '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      meta += '<p class="cart-line__meta">' + escapeHtml(item.variant_title) + '</p>';
    }
    if (item.properties && typeof item.properties === 'object') {
      Object.keys(item.properties).forEach(function (k) {
        var v = item.properties[k];
        if (v && k.charAt(0) !== '_') meta += '<p class="cart-line__meta">' + escapeHtml(k) + ': ' + escapeHtml(v) + '</p>';
      });
    }
    if (item.discounts && item.discounts.length) {
      item.discounts.forEach(function (d) { meta += '<p class="cart-line__discount">' + escapeHtml(d.title) + '</p>'; });
    }

    var price = money(item.final_line_price);
    if (item.original_line_price > item.final_line_price) {
      price = '<s>' + money(item.original_line_price) + '</s> ' + price;
    }
    var each = item.quantity > 1 ? '<span class="cart-line__each">' + money(item.final_price) + ' each</span>' : '';
    var key = escapeHtml(item.key);

    return '<div class="cart-line" data-line-key="' + key + '">' +
      '<a class="cart-line__img" href="' + escapeHtml(url) + '">' + img + '</a>' +
      '<div class="cart-line__body">' +
        '<a class="cart-line__title" href="' + escapeHtml(url) + '">' + escapeHtml(item.product_title) + '</a>' +
        meta +
        '<div class="cart-line__actions">' +
          '<div class="qty" role="group" aria-label="Quantity for ' + escapeHtml(item.product_title) + '">' +
            '<button type="button" class="qty__btn" data-cart-qty="-1" data-key="' + key + '" data-qty="' + item.quantity + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span class="qty__value" aria-live="polite">' + item.quantity + '</span>' +
            '<button type="button" class="qty__btn" data-cart-qty="1" data-key="' + key + '" data-qty="' + item.quantity + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="cart-line__remove" data-cart-remove data-key="' + key + '">Remove</button>' +
        '</div>' +
      '</div>' +
      '<div class="cart-line__price">' + price + each + '</div>' +
    '</div>';
  }

  function renderCart(cart, hint) {
    cartState = cart;

    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-cart-count-label]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });

    if (cartItemsEl) {
      if (!cart.items || !cart.items.length) {
        cartItemsEl.innerHTML =
          '<div class="cart-empty">' +
            '<svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 3.5h2.6l2.1 11.2a1.5 1.5 0 0 0 1.5 1.2h8.6a1.5 1.5 0 0 0 1.5-1.1l1.7-7.1H6"/><circle cx="9.5" cy="20" r="1.3"/><circle cx="17" cy="20" r="1.3"/></svg>' +
            '<p class="cart-empty__title">Your cart is empty</p>' +
            '<p class="cart-empty__text">Looks like you haven’t added any candy yet.</p>' +
            '<a href="' + escapeHtml(R.allProducts || '/collections/all') + '" class="btn btn--primary">Start shopping</a>' +
          '</div>';
      } else {
        cartItemsEl.innerHTML = cart.items.map(cartLineHtml).join('');
      }
    }

    if (cartFooterEl) cartFooterEl.hidden = !(cart.item_count > 0);
    $$('[data-cart-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });

    renderShipping(cart);
    loadRecs(hint);
  }

  /* ---------- free-shipping progress ---------- */
  function renderShipping(cart) {
    if (!shippingEl) return;
    var threshold = Number(T.freeShippingThreshold) || 0;
    if (!threshold || !cart.item_count) { shippingEl.hidden = true; return; }
    var remaining = threshold - cart.total_price;
    var pct = Math.max(0, Math.min(100, (cart.total_price / threshold) * 100));
    var textEl = $('[data-cart-shipping-text]', shippingEl);
    var fillEl = $('[data-cart-shipping-fill]', shippingEl);
    shippingEl.hidden = false;
    shippingEl.classList.toggle('is-complete', remaining <= 0);
    if (textEl) {
      textEl.innerHTML = remaining > 0
        ? 'You’re <strong>' + money(remaining) + '</strong> away from <strong>free shipping</strong>'
        : 'You’ve unlocked <strong>free shipping</strong>!';
    }
    if (fillEl) fillEl.style.width = pct + '%';
  }

  /* ---------- recommendations ---------- */
  function normProduct(p) {
    var variants = p.variants || [];
    var v = variants.filter(function (x) { return x.available; })[0] || variants[0] || {};
    var inCents = typeof p.price === 'number';
    var price = inCents ? p.price : Math.round(parseFloat(v.price || 0) * 100);
    var cmp = 0;
    if (inCents) cmp = Number(p.compare_at_price) || 0;
    else if (v.compare_at_price) cmp = Math.round(parseFloat(v.compare_at_price) * 100);
    var image = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    if (image && typeof image === 'object') image = image.src || '';
    var available = typeof p.available === 'boolean' ? p.available : variants.some(function (x) { return x.available; });
    return {
      id: p.id,
      title: p.title,
      url: p.url || ('/products/' + p.handle),
      image: image,
      price: price,
      compare: cmp,
      variantId: v.id,
      multi: variants.length > 1,
      available: available
    };
  }

  function fetchFallback() {
    if (!fallbackPromise) {
      fallbackPromise = jsonFetch((R.allProducts || '/collections/all') + '/products.json?limit=16')
        .then(function (d) { return (d.products || []).map(normProduct); })
        .catch(function () { return []; });
    }
    return fallbackPromise;
  }

  function fetchRecs(productId) {
    var primary = productId
      ? jsonFetch((R.recommendations || '/recommendations/products') + '.json?product_id=' + productId + '&limit=10&intent=related')
          .then(function (d) { return (d.products || []).map(normProduct); })
          .catch(function () { return []; })
      : Promise.resolve([]);
    return primary.then(function (list) {
      if (list.length >= 4) return list;
      return fetchFallback().then(function (fb) {
        var seen = {};
        list.forEach(function (p) { seen[p.id] = true; });
        return list.concat(fb.filter(function (p) { return !seen[p.id]; }));
      });
    });
  }

  function loadRecs(hint) {
    if (!cartRecsEl || T.showRecommendations === false || !cartState) return;
    var base = hint || currentHint || (cartState.items && cartState.items[0] ? cartState.items[0].product_id : 0) || 0;
    currentHint = hint || currentHint;
    var key = String(base);
    var promise = recsCache[key] || (recsCache[key] = fetchRecs(base));
    promise.then(function (list) { renderRecs(list); });
  }

  function recCardHtml(p) {
    var img = p.image ? '<img src="' + escapeHtml(imgSize(p.image, 320)) + '" alt="' + escapeHtml(p.title) + '" width="160" height="160" loading="lazy">' : '';
    var price = (p.compare > p.price ? '<s>' + money(p.compare) + '</s> ' : '') + money(p.price);
    var action = p.multi
      ? '<a class="rec-card__btn rec-card__btn--ghost" href="' + escapeHtml(p.url) + '">' + escapeHtml(S.selectOptions || 'Select options') + '</a>'
      : '<button type="button" class="rec-card__btn" data-rec-add data-variant-id="' + escapeHtml(p.variantId) + '" data-product-id="' + escapeHtml(p.id) + '">' + escapeHtml(S.addToCart || 'Add to Cart') + '</button>';
    return '<article class="rec-card">' +
      '<a class="rec-card__img" href="' + escapeHtml(p.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
      '<a class="rec-card__title" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
      '<div class="rec-card__price">' + price + '</div>' +
      action +
    '</article>';
  }

  function renderRecs(list) {
    if (!cartRecsEl || !cartRecsList || !cartState) return;
    var inCart = {};
    (cartState.items || []).forEach(function (i) { inCart[i.product_id] = true; });
    var shown = list.filter(function (p) { return p.available && !inCart[p.id]; }).slice(0, 8);
    if (!shown.length) { cartRecsEl.hidden = true; return; }
    if (cartRecsTitle) cartRecsTitle.textContent = cartState.item_count ? 'You may also like' : 'Popular right now';
    cartRecsList.innerHTML = shown.map(recCardHtml).join('');
    cartRecsEl.hidden = false;
  }

  /* ---------- cart network calls ---------- */
  function refreshCart(hint) {
    return jsonFetch(R.cartJson || '/cart.js', { cache: 'no-store' })
      .then(function (cart) { renderCart(cart, hint); return cart; })
      .catch(function (err) { console.error('Cart refresh error:', err); });
  }

  function addToCart(items) {
    return jsonFetch((R.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    });
  }

  function changeLine(key, quantity, wanted) {
    showCartError('');
    var line = $('[data-line-key="' + key + '"]', cartItemsEl);
    if (line) line.classList.add('is-busy');
    return jsonFetch((R.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (cart) {
      renderCart(cart);
      if (wanted) {
        var item = (cart.items || []).filter(function (i) { return i.key === key; })[0];
        if (item && item.quantity < wanted) showCartError('Only ' + item.quantity + ' available for this item.');
      }
    }).catch(function (err) {
      if (line) line.classList.remove('is-busy');
      showCartError(err.message || S.error);
      refreshCart();
    });
  }

  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { closeCart(); return; }

      var qtyBtn = e.target.closest('[data-cart-qty]');
      if (qtyBtn) {
        var current = parseInt(qtyBtn.getAttribute('data-qty'), 10) || 1;
        var delta = parseInt(qtyBtn.getAttribute('data-cart-qty'), 10) || 0;
        var next = Math.max(0, current + delta);
        changeLine(qtyBtn.getAttribute('data-key'), next, delta > 0 ? next : 0);
        return;
      }

      var rm = e.target.closest('[data-cart-remove]');
      if (rm) { changeLine(rm.getAttribute('data-key'), 0, 0); return; }

      var add = e.target.closest('[data-rec-add]');
      if (add) {
        if (add.disabled) return;
        var variantId = add.getAttribute('data-variant-id');
        var productId = parseInt(add.getAttribute('data-product-id'), 10) || 0;
        var label = add.textContent;
        add.disabled = true;
        add.classList.add('is-loading');
        add.textContent = S.adding || 'Adding…';
        showCartError('');
        addToCart([{ id: variantId, quantity: 1 }])
          .then(function () { add.textContent = (S.added || 'Added') + ' ✓'; return refreshCart(productId); })
          .catch(function (err) {
            add.disabled = false; add.classList.remove('is-loading'); add.textContent = label;
            showCartError(err.message || S.error);
          });
      }
    });
  }

  /* anything that should open the cart */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open]');
    if (opener) { e.preventDefault(); openCart(0, opener); return; }

    /* links that point to the old cart page open the drawer instead */
    var link = e.target.closest('a[href]');
    if (link && !e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey && link.target !== '_blank') {
      try {
        var u = new URL(link.href, window.location.origin);
        var cartPath = (R.cart || '/cart').replace(/\/$/, '');
        if (u.origin === window.location.origin && u.pathname.replace(/\/$/, '') === cartPath && !link.closest('#cart-drawer')) {
          e.preventDefault();
          openCart(0, link);
        }
      } catch (err) { /* ignore */ }
    }
  });

  /* sync badge on load + when coming back from the browser cache */
  var warm = function () { refreshCart(); };
  if ('requestIdleCallback' in window) window.requestIdleCallback(warm, { timeout: 2500 });
  else setTimeout(warm, 800);
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* arrived from /cart (redirected here)? open the drawer */
  try {
    if (sessionStorage.getItem('munchin:open-cart')) {
      sessionStorage.removeItem('munchin:open-cart');
      openCart();
    }
  } catch (e) { /* storage blocked */ }


  /* ==========================================================================
     WISHLIST (saved on this device)
     ========================================================================== */
  var WL_KEY = 'munchin:wishlist';
  var wlMemory = [];
  var wlProducts = {};          /* handle -> product json */
  var wishlistDrawer = $('#wishlist-drawer');
  var wishlistItemsEl = $('[data-wishlist-items]');

  function wlRead() {
    try {
      var list = JSON.parse(localStorage.getItem(WL_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) { return wlMemory.slice(); }
  }
  function wlWrite(list) {
    wlMemory = list.slice();
    try { localStorage.setItem(WL_KEY, JSON.stringify(list)); } catch (e) { /* storage blocked: memory only */ }
  }
  function wlHas(handle) { return wlRead().indexOf(handle) > -1; }

  function wlToggle(handle) {
    var list = wlRead();
    var i = list.indexOf(handle);
    if (i > -1) list.splice(i, 1);
    else { list.unshift(handle); list = list.slice(0, 60); }
    wlWrite(list);
    wlSync();
    return i === -1;
  }

  function wlSync() {
    var list = wlRead();
    $$('[data-wishlist-count]').forEach(function (el) { el.textContent = list.length; });
    $$('[data-wishlist-count-label]').forEach(function (el) { el.textContent = '(' + list.length + ')'; });
    $$('[data-wishlist-toggle]').forEach(function (btn) {
      var on = list.indexOf(btn.getAttribute('data-handle')) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (wishlistDrawer && wishlistDrawer.classList.contains('is-open')) renderWishlist();
  }

  function wlLoadProduct(handle) {
    if (wlProducts[handle]) return Promise.resolve(wlProducts[handle]);
    return jsonFetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (p) { wlProducts[handle] = p; return p; })
      .catch(function (err) { return { __failed: true, __missing: err && err.status === 404 }; });
  }

  function wlItemHtml(p) {
    var variants = p.variants || [];
    var v = variants.filter(function (x) { return x.available; })[0] || variants[0] || {};
    var multi = variants.length > 1;
    var image = p.featured_image ? '<img src="' + escapeHtml(imgSize(p.featured_image, 200)) + '" alt="' + escapeHtml(p.title) + '" width="88" height="88" loading="lazy">' : '';
    var price = (p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price) + '</s> ' : '') + (p.price_varies ? 'From ' : '') + money(p.price);
    var action;
    if (!p.available) action = '<span class="wl-item__soldout">Sold out</span>';
    else if (multi) action = '<a class="wl-item__btn wl-item__btn--ghost" href="' + escapeHtml(p.url) + '">' + escapeHtml(S.selectOptions || 'Select options') + '</a>';
    else action = '<button type="button" class="wl-item__btn" data-wl-add data-variant-id="' + escapeHtml(v.id) + '" data-product-id="' + escapeHtml(p.id) + '">' + escapeHtml(S.addToCart || 'Add to Cart') + '</button>';
    return '<div class="wl-item" data-handle="' + escapeHtml(p.handle) + '">' +
      '<a class="wl-item__img" href="' + escapeHtml(p.url) + '">' + image + '</a>' +
      '<div class="wl-item__body">' +
        '<a class="wl-item__title" href="' + escapeHtml(p.url) + '">' + escapeHtml(p.title) + '</a>' +
        '<div class="wl-item__price">' + price + '</div>' +
        '<div class="wl-item__actions">' + action +
          '<button type="button" class="wl-item__remove" data-wl-remove data-handle="' + escapeHtml(p.handle) + '">Remove</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function renderWishlist() {
    if (!wishlistItemsEl) return;
    var list = wlRead();
    if (!list.length) {
      wishlistItemsEl.innerHTML =
        '<div class="cart-empty">' +
          '<svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.5s-8-4.8-8-11A4.6 4.6 0 0 1 12 6.8a4.6 4.6 0 0 1 8 2.7c0 6.2-8 11-8 11z"/></svg>' +
          '<p class="cart-empty__title">Your wishlist is empty</p>' +
          '<p class="cart-empty__text">Tap the heart on any product to save it for later.</p>' +
          '<a href="' + escapeHtml(R.allProducts || '/collections/all') + '" class="btn btn--primary">Browse candy</a>' +
        '</div>';
      return;
    }
    if (!wishlistItemsEl.children.length || wishlistItemsEl.querySelector('.cart-empty')) {
      wishlistItemsEl.innerHTML = '<p class="cart-drawer__loading">Loading…</p>';
    }
    Promise.all(list.map(wlLoadProduct)).then(function (products) {
      var current = wlRead();
      var html = '';
      var missing = [];
      products.forEach(function (p, i) {
        if (p && p.__failed) { if (p.__missing) missing.push(list[i]); }   /* only drop products that were really deleted (404) */
        else if (p) html += wlItemHtml(p);
      });
      if (missing.length) {      /* product was deleted from the store */
        wlWrite(current.filter(function (h) { return missing.indexOf(h) === -1; }));
        wlSync();
        return;
      }
      wishlistItemsEl.innerHTML = html;
    });
  }

  function openWishlist(trigger) {
    if (!wishlistDrawer) return;
    renderWishlist();
    openDrawer(wishlistDrawer, trigger);
  }

  document.addEventListener('click', function (e) {
    var heart = e.target.closest('[data-wishlist-toggle]');
    if (heart) {
      e.preventDefault();
      e.stopPropagation();
      var handle = heart.getAttribute('data-handle');
      var added = wlToggle(handle);
      if (added) { heart.classList.remove('pop'); void heart.offsetWidth; heart.classList.add('pop'); }
      return;
    }
    var opener = e.target.closest('[data-wishlist-open]');
    if (opener) { e.preventDefault(); openWishlist(opener); return; }
    if (e.target.closest('[data-wishlist-close]')) { closeDrawer(wishlistDrawer); return; }

    var rm = e.target.closest('[data-wl-remove]');
    if (rm) { wlToggle(rm.getAttribute('data-handle')); return; }

    var add = e.target.closest('[data-wl-add]');
    if (add && !add.disabled) {
      var label = add.textContent;
      var pid = parseInt(add.getAttribute('data-product-id'), 10) || 0;
      add.disabled = true; add.textContent = S.adding || 'Adding…';
      addToCart([{ id: add.getAttribute('data-variant-id'), quantity: 1 }])
        .then(function () { add.textContent = (S.added || 'Added') + ' ✓'; return refreshCart(pid); })
        .then(function () { setTimeout(function () { openCart(pid); }, 350); })
        .catch(function (err) { add.disabled = false; add.textContent = label; console.error(err); });
    }
  });

  window.addEventListener('storage', function (e) { if (e.key === WL_KEY) wlSync(); });
  wlSync();

  /* ==========================================================================
     Quantity stepper (product page)
     ========================================================================== */
  $$('[data-qty-minus], [data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrapper = btn.closest('.quantity-stepper');
      var input = $('input[type="number"]', wrapper);
      var val = parseInt(input.value, 10) || 1;
      if (btn.hasAttribute('data-qty-plus')) val += 1;
      if (btn.hasAttribute('data-qty-minus')) val = Math.max(1, val - 1);
      input.value = val;
    });
  });

  /* ---------------- Product gallery thumbs ---------------- */
  var thumbs = $$('.product-gallery__thumb');
  var mainImg = $('#ProductMainImage');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.getAttribute('data-full');
    });
  });

  /* ==========================================================================
     Product form: variants, price, add to cart (opens drawer), buy now
     ========================================================================== */
  var productForm = $('#ProductForm');
  if (productForm) {
    var variantSelect = $('#ProductVariantSelect');
    var priceEl = $('#ProductPrice');
    var compareEl = $('#ProductComparePrice');
    var addBtn = $('[data-add-to-cart]', productForm);
    var buyBtn = $('[data-buy-now]', productForm);
    var errorEl = $('#ProductFormError');
    var qtyInput = $('#Quantity');
    var dataEl = $('#ProductVariantData');
    var productId = parseInt(productForm.getAttribute('data-product-id'), 10) || 0;

    var variants = [];
    if (dataEl) {
      try { variants = (JSON.parse(dataEl.textContent) || {}).variants || []; }
      catch (err) { console.error('Variant data parse error:', err); }
    }

    var showError = function (msg) {
      if (!errorEl) return;
      if (msg) { errorEl.textContent = msg; errorEl.hidden = false; }
      else { errorEl.textContent = ''; errorEl.hidden = true; }
    };

    var selectedOptions = function () {
      return $$('.product-form__swatches', productForm).map(function (group) {
        var active = $('.swatch.active', group);
        return active ? active.getAttribute('data-value') : null;
      });
    };

    var findVariant = function (values) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], match = true;
        for (var j = 0; j < values.length; j++) {
          if (values[j] === null || String(v.options[j]) !== String(values[j])) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    };

    var currentVariant = function () {
      var values = selectedOptions();
      if (!values.length) {
        var id = variantSelect ? variantSelect.value : null;
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(id)) return variants[i];
        }
        return variants[0] || null;
      }
      return findVariant(values);
    };

    var refreshButtons = function (variant) {
      var available = variant && variant.available;
      if (addBtn) {
        addBtn.disabled = !available;
        if (!variant) addBtn.textContent = 'Unavailable';
        else if (!available) addBtn.textContent = S.soldOut || 'Sold Out';
        else addBtn.textContent = (addBtn.getAttribute('data-label-prefix') || '') + variant.price_formatted;
      }
      if (buyBtn) buyBtn.disabled = !available;
    };

    var updateVariant = function () {
      var variant = currentVariant();
      showError('');
      if (variant && variantSelect) variantSelect.value = variant.id;
      if (variant && priceEl) priceEl.textContent = variant.price_formatted;
      if (compareEl) {
        if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = variant.compare_at_price_formatted;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (variant && variant.featured_image && mainImg) mainImg.src = variant.featured_image;
      refreshButtons(variant);
      /* keep the URL shareable */
      if (variant && window.history && history.replaceState) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', variant.id); history.replaceState({}, '', u); } catch (e) { /* ignore */ }
      }
    };

    var refreshAvailability = function () {
      var values = selectedOptions();
      $$('.product-form__swatches', productForm).forEach(function (group, groupIndex) {
        $$('.swatch', group).forEach(function (sw) {
          var test = values.slice();
          test[groupIndex] = sw.getAttribute('data-value');
          var match = findVariant(test);
          sw.classList.toggle('is-unavailable', !(match && match.available));
        });
      });
    };

    $$('.swatch', productForm).forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        var group = swatch.closest('.product-form__swatches');
        $$('.swatch', group).forEach(function (s) { s.classList.remove('active'); s.setAttribute('aria-pressed', 'false'); });
        swatch.classList.add('active');
        swatch.setAttribute('aria-pressed', 'true');
        updateVariant();
        refreshAvailability();
      });
    });

    updateVariant();
    refreshAvailability();

    var selectedQuantity = function () {
      var qty = parseInt(qtyInput ? qtyInput.value : '1', 10);
      return qty > 0 ? qty : 1;
    };

    var submitCart = function (btn, thenCheckout) {
      var variant = currentVariant();
      if (!variant || !variant.available) { showError('This option is sold out.'); return; }
      if (btn.disabled) return;

      var original = btn.textContent;
      btn.disabled = true;
      btn.classList.add('is-loading');
      btn.textContent = thenCheckout ? 'Redirecting…' : (S.adding || 'Adding…');
      showError('');

      addToCart([{ id: variant.id, quantity: selectedQuantity() }])
        .then(function () {
          if (thenCheckout) { window.location.href = (R.root || '/') + 'checkout'; return; }
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          btn.textContent = (S.added || 'Added') + ' ✓';
          openCart(productId, btn);
          setTimeout(function () {
            btn.classList.remove('is-added');
            btn.disabled = false;
            refreshButtons(currentVariant());
          }, 1400);
        })
        .catch(function (err) {
          console.error('Add to cart error:', err);
          btn.classList.remove('is-loading');
          btn.textContent = original;
          btn.disabled = false;
          showError(err.message || S.error);
        });
    };

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn) submitCart(addBtn, false);
    });
    if (buyBtn) {
      buyBtn.addEventListener('click', function (e) { e.preventDefault(); submitCart(buyBtn, true); });
    }
  }

  /* ==========================================================================
     Quick add buttons on product cards
     ========================================================================== */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;
    var pid = parseInt(btn.getAttribute('data-product-id'), 10) || 0;
    var original = btn.textContent;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = S.adding || 'Adding…';

    addToCart([{ id: variantId, quantity: 1 }])
      .then(function () {
        btn.classList.remove('is-loading');
        btn.textContent = (S.added || 'Added') + ' ✓';
        openCart(pid, btn);
        setTimeout(function () { btn.textContent = original || 'Add to Cart'; btn.disabled = false; }, 1400);
      })
      .catch(function (err) {
        console.error('Quick add error:', err);
        btn.classList.remove('is-loading');
        btn.textContent = original || 'Add to Cart';
        btn.disabled = false;
        openCart(0, btn);
        showCartError(err.message || S.error);
      });
  });

  /* ==========================================================================
     HERO SLIDER
     ========================================================================== */
  function initHeroSlider(sliderEl) {
    if (!sliderEl || sliderEl._hs) return;
    var track = $('[data-hs-track]', sliderEl);
    var viewport = $('[data-hs-viewport]', sliderEl);
    var slides = $$('[data-hs-slide]', sliderEl);
    var dots = $$('[data-hs-dot]', sliderEl);
    var count = slides.length;
    if (!track || !count) return;

    var delay = parseInt(sliderEl.getAttribute('data-delay'), 10) || 6000;
    var wantsAutoplay = sliderEl.getAttribute('data-autoplay') === 'true' && count > 1 && !reduceMotion;
    var index = 0;
    var userPaused = false;

    sliderEl.style.setProperty('--hs-delay', delay + 'ms');

    function setPaused(on) { sliderEl.classList.toggle('is-paused', !!on); }

    function go(i) {
      index = (i + count) % count;
      track.style.transform = 'translate3d(' + (-index * 100) + '%,0,0)';
      slides.forEach(function (s, n) {
        var active = n === index;
        s.classList.toggle('is-active', active);
        if (active) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        $$('a, button', s).forEach(function (el) { el.tabIndex = active ? 0 : -1; });
      });
      dots.forEach(function (d, n) {
        var active = n === index;
        d.classList.remove('is-active');
        if (active) { void d.offsetWidth; d.classList.add('is-active'); }   /* restart the progress animation */
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    var prev = $('[data-hs-prev]', sliderEl), next = $('[data-hs-next]', sliderEl);
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hs-dot'), 10) || 0); });
    });

    /* autoplay is driven by the CSS progress bar in the active dot: when it ends, go to the next slide */
    if (wantsAutoplay) {
      sliderEl.classList.add('is-autoplay');
      dots.forEach(function (d) {
        var bar = $('span', d);
        if (bar) bar.addEventListener('animationend', function () { if (d.classList.contains('is-active')) go(index + 1); });
      });

      sliderEl.addEventListener('mouseenter', function () { setPaused(true); });
      sliderEl.addEventListener('mouseleave', function () { if (!userPaused) setPaused(false); });
      sliderEl.addEventListener('focusin', function () { setPaused(true); });
      sliderEl.addEventListener('focusout', function () { if (!userPaused) setPaused(false); });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) setPaused(true); else if (!userPaused) setPaused(false);
      });

      var pauseBtn = $('[data-hs-pause]', sliderEl);
      if (pauseBtn) {
        pauseBtn.addEventListener('click', function () {
          userPaused = !userPaused;
          setPaused(userPaused);
          pauseBtn.setAttribute('aria-pressed', userPaused ? 'true' : 'false');
          pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
          pauseBtn.classList.toggle('is-paused', userPaused);
        });
      }
    }

    /* swipe */
    var startX = 0, startY = 0, tracking = false;
    viewport.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tracking = true; startX = e.touches[0].clientX; startY = e.touches[0].clientY;
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - startX, dy = t.clientY - startY;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.2) go(dx < 0 ? index + 1 : index - 1);
    }, { passive: true });

    /* keyboard */
    sliderEl.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(index - 1); }
      else if (e.key === 'ArrowRight') { go(index + 1); }
    });

    sliderEl._hs = { go: go, pause: function () { userPaused = true; setPaused(true); } };
    go(0);
  }

  $$('[data-hero-slider]').forEach(initHeroSlider);

  /* Shopify theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-hero-slider]', e.target).forEach(initHeroSlider);
    wlSync();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest && e.target.closest('[data-hs-slide]');
    if (!slide) return;
    var slider = slide.closest('[data-hero-slider]');
    if (slider && slider._hs) {
      slider._hs.go($$('[data-hs-slide]', slider).indexOf(slide));
      slider._hs.pause();
    }
  });


  /* ==========================================================================
     Collection page: sorting + filters (keeps the other filters in the URL)
     ========================================================================== */
  var sortSelect = $('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sortSelect.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  }
  $$('[data-filter-url]').forEach(function (cb) {
    cb.addEventListener('change', function () { window.location.href = cb.getAttribute('data-filter-url'); });
  });

  /* ==========================================================================
     Collection page: automatic "infinite" product loading (all products on page 1)
     ========================================================================== */
  var infGrid = $('[data-infinite-grid]');
  if (infGrid) {
    var infNext = infGrid.getAttribute('data-next-url');
    var infSentinel = $('[data-infinite-sentinel]');
    var infStatus = $('[data-infinite-status]');
    var infText = $('[data-infinite-text]');
    var infLoading = false;

    var infLoad = function () {
      if (infLoading || !infNext) return;
      infLoading = true;
      if (infStatus) { infStatus.hidden = false; infStatus.classList.remove('is-done'); }
      fetch(infNext, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) { if (!res.ok) throw new Error('page'); return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = doc.querySelector('[data-infinite-grid]');
          if (!grid) throw new Error('grid');
          $$('.product-card', grid).forEach(function (card) {
            card.classList.add('is-visible');
            card.style.transitionDelay = '0ms';
            infGrid.appendChild(document.importNode(card, true));
          });
          infNext = grid.getAttribute('data-next-url');
          wlSync();
          infLoading = false;
          if (!infNext) {
            if (infText) infText.textContent = 'You\u2019ve seen all products';
            if (infStatus) infStatus.classList.add('is-done');
            if (infObserver) infObserver.disconnect();
          } else {
            if (infStatus) infStatus.hidden = true;
            if (infObserver && infSentinel) { infObserver.unobserve(infSentinel); infObserver.observe(infSentinel); }   /* re-check if still in view */
          }
        })
        .catch(function () {
          infLoading = false;
          if (infStatus) infStatus.hidden = true;
          if (infNext) window.location.href = infNext;      /* fall back to a normal page load */
        });
    };

    var infObserver = null;
    if (infSentinel && infNext) {
      if ('IntersectionObserver' in window) {
        infObserver = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) infLoad();
        }, { rootMargin: '900px 0px' });
        infObserver.observe(infSentinel);
      } else {
        infLoad();
      }
    }
  }

  /* ==========================================================================
     Product page: sticky add-to-cart bar (phones)
     ========================================================================== */
  var stickyBar = $('[data-product-sticky]');
  if (stickyBar && productForm) {
    var stAdd = $('[data-sticky-add]', stickyBar), stBuy = $('[data-sticky-buy]', stickyBar), stPrice = $('[data-sticky-price]', stickyBar);
    var mainAdd = $('[data-add-to-cart]', productForm), mainBuy = $('[data-buy-now]', productForm);
    if (mainAdd && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var out = !e.isIntersecting && e.boundingClientRect.top < 0;
        stickyBar.hidden = !out;
        document.body.classList.toggle('has-sticky-cart', out);
      }, { threshold: 0 }).observe(mainAdd);
    }
    var syncSticky = function () {
      if (stAdd && mainAdd) { stAdd.disabled = mainAdd.disabled; stAdd.textContent = mainAdd.disabled ? mainAdd.textContent : (S.addToCart || 'Add to Cart'); }
      if (stBuy && mainBuy) stBuy.disabled = mainBuy.disabled;
      var p = $('#ProductPrice'); if (p && stPrice) stPrice.textContent = p.textContent;
    };
    if (mainAdd) new MutationObserver(syncSticky).observe(mainAdd, { childList: true, characterData: true, subtree: true, attributes: true });
    var pe = $('#ProductPrice'); if (pe) new MutationObserver(syncSticky).observe(pe, { childList: true, characterData: true, subtree: true });
    if (stAdd) stAdd.addEventListener('click', function () { if (mainAdd) mainAdd.click(); });
    if (stBuy) stBuy.addEventListener('click', function () { if (mainBuy) mainBuy.click(); });
    syncSticky();
  }

  /* ---------------- Pick & Mix builder (3 bags + modal) ---------------- */
  document.querySelectorAll('[data-pick-mix]').forEach(function (root) {
    var modal = root.querySelector('[data-pm-modal]');
    if (!modal) return;

    /* move the modal to <body> so it is never clipped by the section */
    document.body.appendChild(modal);

    var requireFull = root.getAttribute('data-pm-require-full') !== 'false';
    var panel = modal.querySelector('.pm-modal__panel');
    var grid = modal.querySelector('[data-pm-grid]');
    var tiles = Array.prototype.slice.call(modal.querySelectorAll('[data-pm-tile]'));
    var titleEl = modal.querySelector('[data-pm-title-label]');
    var needEl = modal.querySelector('[data-pm-need]');
    var maxEl = modal.querySelector('[data-pm-max]');
    var countEl = modal.querySelector('[data-pm-count]');
    var totalEl = modal.querySelector('[data-pm-total]');
    var hintEl = modal.querySelector('[data-pm-hint]');
    var slotsEl = modal.querySelector('[data-pm-slots]');
    var submitBtn = modal.querySelector('[data-pm-submit]');
    var clearBtn = modal.querySelector('[data-pm-clear]');
    var searchEl = modal.querySelector('[data-pm-search]');
    var emptyEl = modal.querySelector('[data-pm-empty]');
    var counterEl = modal.querySelector('.pm-modal__counter');

    var max = 4;
    var bagLabel = '';
    var bagVariant = '';   /* fixed-price bag variant id */
    var bagPrice = 0;      /* fixed bag price in cents */
    var mix = {};      /* variantId -> {title, price, image, qty} */
    var order = [];    /* variant ids in the order they were added (one entry per candy) */
    var lastFocus = null;

    function total() { return order.length; }

    function render() {
      var n = total();

      countEl.textContent = n;
      maxEl.textContent = max;
      needEl.textContent = max;
      titleEl.textContent = bagLabel;
      totalEl.textContent = bagPrice ? money(bagPrice) : '';
      counterEl.classList.toggle('is-full', n >= max);
      clearBtn.hidden = n === 0;

      /* tiles */
      tiles.forEach(function (tile) {
        var id = tile.getAttribute('data-pm-variant');
        var qty = mix[id] ? mix[id].qty : 0;
        var stepper = tile.querySelector('[data-pm-stepper]');
        tile.classList.toggle('is-selected', qty > 0);
        if (stepper) {
          stepper.hidden = qty === 0;
          stepper.querySelector('[data-pm-qty]').textContent = qty;
          var plus = stepper.querySelector('[data-pm-plus]');
          if (plus) plus.disabled = n >= max;
        }
      });
      grid.classList.toggle('is-full', n >= max);

      /* slots */
      slotsEl.innerHTML = '';
      for (var i = 0; i < max; i++) {
        var slot = document.createElement('button');
        slot.type = 'button';
        slot.className = 'pm-slot';
        var id = order[i];
        if (id) {
          slot.classList.add('is-filled');
          slot.setAttribute('data-id', id);
          slot.setAttribute('aria-label', 'Remove ' + mix[id].title);
          slot.title = 'Remove ' + mix[id].title;
          if (mix[id].image) {
            var img = document.createElement('img');
            img.src = mix[id].image; img.alt = '';
            slot.appendChild(img);
          } else {
            slot.textContent = '🍬';
          }
        } else {
          slot.disabled = true;
          slot.setAttribute('aria-label', 'Empty spot');
          slot.textContent = i + 1;
        }
        slotsEl.appendChild(slot);
      }

      /* hint + submit state */
      var left = max - n;
      if (n === 0) hintEl.textContent = 'Pick ' + max + ' candies to fill your bag';
      else if (left > 0) hintEl.textContent = 'Pick ' + left + ' more ' + (left === 1 ? 'candy' : 'candies') + ' to fill your bag';
      else hintEl.textContent = 'Your bag is full — ready to add to cart.';
      hintEl.classList.toggle('is-ready', left === 0);
      submitBtn.disabled = requireFull ? left !== 0 : n === 0;
    }

    function money(cents) { return '$' + (cents / 100).toFixed(2); }

    function addCandy(id, tile) {
      if (total() >= max) { shake(); return; }
      if (!mix[id]) {
        mix[id] = {
          title: tile.getAttribute('data-pm-title'),
          image: tile.getAttribute('data-pm-image'),
          qty: 0
        };
      }
      mix[id].qty += 1;
      order.push(id);
      tile.classList.remove('pop'); void tile.offsetWidth; tile.classList.add('pop');
      render();
      var filled = slotsEl.querySelectorAll('.pm-slot.is-filled');
      var last = filled[filled.length - 1];
      if (last) { last.classList.add('pop'); }
    }

    function removeCandy(id) {
      if (!mix[id]) return;
      var idx = order.lastIndexOf(id);
      if (idx > -1) order.splice(idx, 1);
      mix[id].qty -= 1;
      if (mix[id].qty <= 0) delete mix[id];
      render();
    }

    function shake() {
      counterEl.classList.remove('shake'); void counterEl.offsetWidth; counterEl.classList.add('shake');
    }

    function resetMix() { mix = {}; order = []; }

    function openModal(size, label, trigger) {
      max = size;
      bagLabel = label;
      bagVariant = (trigger && trigger.getAttribute('data-pm-bag-variant')) || '';
      bagPrice = parseInt(trigger && trigger.getAttribute('data-pm-bag-price'), 10) || 0;
      resetMix();
      if (searchEl) { searchEl.value = ''; filterTiles(''); }
      lastFocus = trigger || document.activeElement;
      modal.hidden = false;
      document.body.classList.add('pm-lock');
      requestAnimationFrame(function () {
        modal.classList.add('is-open');
        if (panel) panel.focus({ preventScroll: true });
      });
      var body = modal.querySelector('.pm-modal__body');
      if (body) body.scrollTop = 0;
      render();
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.body.classList.remove('pm-lock');
      setTimeout(function () { modal.hidden = true; }, 260);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }

    function filterTiles(q) {
      q = (q || '').trim().toLowerCase();
      var shown = 0;
      tiles.forEach(function (tile) {
        var hit = !q || (tile.getAttribute('data-pm-search-text') || '').indexOf(q) > -1;
        tile.hidden = !hit;
        if (hit) shown++;
      });
      if (emptyEl) emptyEl.hidden = shown > 0;
    }

    /* open from the 3 bag cards */
    root.querySelectorAll('[data-pm-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(parseInt(btn.getAttribute('data-pm-size'), 10) || 4, btn.getAttribute('data-pm-label') || '', btn);
      });
    });

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-pm-close]')) { closeModal(); return; }

      var tile = e.target.closest('[data-pm-tile]');
      if (tile) {
        var id = tile.getAttribute('data-pm-variant');
        if (e.target.closest('[data-pm-minus]')) { removeCandy(id); return; }
        if (e.target.closest('[data-pm-plus]')) { addCandy(id, tile); return; }
        if (e.target.closest('[data-pm-add]')) { addCandy(id, tile); return; }
      }

      var slot = e.target.closest('.pm-slot.is-filled');
      if (slot) { removeCandy(slot.getAttribute('data-id')); }
    });

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') { closeModal(); return; }
      if (e.key === 'Tab') {
        var f = modal.querySelectorAll('button:not([disabled]):not([hidden]), input');
        var vis = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null; });
        if (!vis.length) return;
        var first = vis[0], last = vis[vis.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    if (searchEl) searchEl.addEventListener('input', function () { filterTiles(searchEl.value); });

    clearBtn.addEventListener('click', function () { resetMix(); render(); });

    submitBtn.addEventListener('click', function () {
      if (submitBtn.disabled || !order.length) return;
      if (!bagVariant) {
        console.warn('Pick & Mix: no bag product linked. In Theme Editor > Pick & Mix, select the Bag product for this size.');
        hintEl.textContent = 'This bag is not available right now. Please try another size.';
        hintEl.classList.remove('is-ready');
        return;
      }
      /* ONE cart line = the fixed-price bag. Chosen candies are saved as a line-item property. */
      var candyList = [];
      var seen = {};
      order.forEach(function (id) {
        if (!seen[id]) { seen[id] = true; candyList.push(mix[id].title + (mix[id].qty > 1 ? ' x' + mix[id].qty : '')); }
      });
      var props = { 'Pick & Mix Bag': bagLabel, 'Candies': candyList.join(', ') };
      var items = [{ id: bagVariant, quantity: 1, properties: props }];
      var original = submitBtn.textContent;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';

      addToCart(items)
        .then(function () {
          submitBtn.textContent = 'Added ✓';
          return refreshCart();
        })
        .then(function () {
          setTimeout(function () {
            closeModal();
            resetMix();
            submitBtn.textContent = original;
            render();
            openCart();
          }, 400);
        })
        .catch(function (err) {
          console.error('Pick & Mix add error:', err);
          submitBtn.textContent = original;
          hintEl.textContent = (err && err.message) ? err.message : 'Could not add to cart. Please try again.';
          hintEl.classList.remove('is-ready');
          submitBtn.disabled = false;
        });
    });
  });


});
